import { useState, useEffect } from 'react';
import { Icon } from '../icons/Icon';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AreaChart, Area, ResponsiveContainer } from 'recharts';
import { api } from '@/services/api';

const initialData = [
    { name: 'Mon', uv: 0, pv: 0, amt: 0 },
    { name: 'Tue', uv: 0, pv: 0, amt: 0 },
    { name: 'Wed', uv: 0, pv: 0, amt: 0 },
    { name: 'Thu', uv: 0, pv: 0, amt: 0 },
    { name: 'Fri', uv: 0, pv: 0, amt: 0 },
    { name: 'Sat', uv: 0, pv: 0, amt: 0 },
    { name: 'Sun', uv: 0, pv: 0, amt: 0 },
];

export const KPIDashboard = () => {
    const [stats, setStats] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            const res = await api.getAdminStats();
            if (res.success) {
                setStats(res.data);
            }
            setLoading(false);
        };
        fetchStats();
    }, []);

    if (loading) return <div className="text-ink animate-pulse">Loading Analytics...</div>;
    if (!stats) return <div className="text-red-500">Failed to load data</div>;

    const chartData = stats.dau.map((d: any) => ({ name: d.date, uv: d.value }));

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            <Card className="bg-surface border-primary/20">
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-sm font-medium text-muted-foreground">総発行ポイント (Total Points)</CardTitle>
                    <span className="text-primary font-bold">P</span>
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold font-display text-ink">{stats.revenue.toLocaleString()} P</div>
                    <p className="text-xs text-muted-foreground">Total Issued Economy</p>
                    <div className="h-[80px] mt-4 w-full">
                        <ResponsiveContainer width="100%" height="100%">
                            <AreaChart data={chartData.length > 0 ? chartData : initialData}>
                                <defs>
                                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#00f3ff" stopOpacity={0.3} />
                                        <stop offset="95%" stopColor="#00f3ff" stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                                <Area type="monotone" dataKey="uv" stroke="#00f3ff" fillOpacity={1} fill="url(#colorUv)" />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>
                </CardContent>
            </Card>

            <Card className="bg-surface border-pop/20">
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-sm font-medium text-muted-foreground">アクティブユーザー (24h)</CardTitle>
                    <span className="text-pop font-bold"><Icon name="user" size={16} /></span>
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold font-display text-ink">{stats.dau[0]?.value || 0}</div>
                    <p className="text-xs text-muted-foreground">Online within 24h</p>
                </CardContent>
            </Card>
            <Card className="bg-surface border-role-voice/20">
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-sm font-medium text-muted-foreground">総作品数</CardTitle>
                    <span className="text-role-voice font-bold"><Icon name="voice" size={16} /></span>
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold font-display text-ink">{stats.totalSubmissions.toLocaleString()}</div>
                    <p className="text-xs text-muted-foreground">Total Voices</p>
                </CardContent>
            </Card>
            <Card className="bg-surface border-yellow-400/20">
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-sm font-medium text-muted-foreground">登録ユーザー</CardTitle>
                    <span className="text-yellow-400 font-bold">●</span>
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold font-display text-ink">{stats.totalUsers.toLocaleString()}</div>
                    <p className="text-xs text-muted-foreground">Total Accounts</p>
                </CardContent>
            </Card>
        </div>
    );
};
